import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// SYSTEM1
import BaseMixer from "@/router/views/BaseMixer";
import { DashboardModule } from "@/store/modules/dashboard.module";
let USMap = /** @class */ (() => {
    let USMap = class USMap extends Mixins(BaseMixer) {
        getDataInfo(stateCode, stateName) {
            var state = this.mapStates.find((x) => x.stateCode == stateCode);
            return !!state
                ? `<div><strong>State</strong>: ${stateName}</div><div><strong>Entries</strong>: ${state.entriesCount}</div>`
                : `<div><strong>State:</strong> ${stateName}</div><div><strong>Entries:</strong> 0</div>`;
        }
        getFillOpacity(stateCode) {
            var state = this.mapStates.find((x) => x.stateCode == stateCode);
            return !!state ? state.percentage : 100;
        }
        getFillColor(stateCode) {
            var state = this.mapStates.find((x) => x.stateCode == stateCode);
            return !!state ? "#4ab051" : "#f6f6f6";
        }
        mounted() {
            document.querySelectorAll("path, circle, rect").forEach(function (element) {
                // Skip line element in the map section
                if (element.id == "path67")
                    return;
                let parent = element.parentElement;
                while (parent) {
                    if (parent.tagName.toLowerCase() === "svg") {
                        break;
                    }
                    parent = parent.parentElement;
                }
                if (parent && parent.id == "us-map") {
                    element.addEventListener("mouseenter", function (e) {
                        var targetElement = e.target;
                        if (!DashboardModule.clientDetail || DashboardModule.clientDetail.isAllStatesAssociated || DashboardModule.clientDetail.associatedStates.some((x) => targetElement.id.endsWith(x))) {
                            var infoBox = document.getElementById("info-box");
                            infoBox.style.display = "block";
                            infoBox.innerHTML = element.getAttribute("data-info");
                        }
                    });
                    element.addEventListener("mouseleave", function (e) {
                        var infoBox = document.getElementById("info-box");
                        infoBox.style.display = "none";
                    });
                }
            });
            document.addEventListener("mousemove", function (e) {
                var infoBox = document.getElementById("info-box");
                //infoBox.style.top = e.pageY - infoBox.offsetHeight - 30 + "px";
                //infoBox.style.left = e.pageX - infoBox.offsetWidth / 2 + "px";
                //infoBox.style.top = e.pageY - infoBox.offsetHeight - 400 + "px";
                //infoBox.style.left = e.pageX - infoBox.offsetWidth - 400 + "px";
                var usMap = document.getElementById("us-map");
                if (infoBox && usMap) {
                    const svgRect = usMap.getBoundingClientRect();
                    const mouseX = e.clientX - svgRect.left;
                    const mouseY = e.clientY - svgRect.top;
                    infoBox.style.left = `${mouseX - 50}px`;
                    infoBox.style.top = `${mouseY + 20}px`;
                }
            });
            var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window["MSStream"];
            if (ios) {
                document.querySelectorAll("a").forEach(function (anchor) {
                    anchor.addEventListener("click", function (e) {
                        var link = anchor.getAttribute("href");
                        window.open(link, "_blank");
                        e.preventDefault();
                    });
                    anchor.addEventListener("touchend", function (e) {
                        var link = anchor.getAttribute("href");
                        window.open(link, "_blank");
                        e.preventDefault();
                    });
                });
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], USMap.prototype, "mapStates", void 0);
    USMap = __decorate([
        Component({
            name: "USMap",
            components: {},
        })
    ], USMap);
    return USMap;
})();
export default USMap;
